import {
  updateRangeFacet,
  clearRangeFacet,
  setRangeValues,
  undoRangeValues
} from "../store/actionCreators";
import {
  commandUpdateRangeFacet,
  commandClearRangeFacet,
  commandSetRangeValues
} from "./reducers";

export const registerPriceRangeSlice = (
  builder,
  { calculateHasSelectedValuesState, getPriceRange }
) => {
  builder
    .addCase(updateRangeFacet, (state, { payload }) =>
      commandUpdateRangeFacet(state, payload, {
        calculateHasSelectedValuesState,
        getPriceRange
      })
    )
    .addCase(clearRangeFacet, state =>
      commandClearRangeFacet(state, { getPriceRange })
    )
    .addCase(setRangeValues, (state, { payload }) =>
      commandSetRangeValues(state, payload, { calculateHasSelectedValuesState })
    )
    .addCase(undoRangeValues, state => {
      if (state.range.currentprice.selected.previous) {
        state.range.currentprice.selected.current =
          state.range.currentprice.selected.previous;
        state.range.currentprice.selected.previous = null;
      }
    });
};
